import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router, Routes } from '@angular/router';
import { RemoteConfigResolver } from '@softline/application';
import { AuthenticationGuard, AuthorizationGuard } from '@softline/auth';
import { Store } from '@softline/core';
import {
  SOFTLINE_FEATURE_MDE_INVENTUR,
  SOFTLINE_PERMISSION_MDE_INVENTUR,
} from './inventur.shared';
import { InventurResolver } from './resolver/inventur.resolver';
import { InventurStore } from './store/inventur.store';

const hasKopfGuard: CanActivateFn = (route) => {
  const kopf = route.data?.['inventur']?.kopf;

  if (!!kopf && kopf?.lager) return true;

  const store = inject(Store);

  const belegdatum = store.get(
    SOFTLINE_FEATURE_MDE_INVENTUR,
    InventurStore.getters.belegdatum
  );
  const lager = store.get(SOFTLINE_FEATURE_MDE_INVENTUR, InventurStore.getters.lager);

  if (lager && belegdatum) {
    return true;
  }

  const urlTree = inject(Router).createUrlTree(['/mde-inventur/start']);
  return new RedirectCommand(urlTree, { replaceUrl: false });
};

/**
 * @deprecated: Use provideMdeInventoryModule() instead
 */
export const lagerInventurRoutes: Routes = [
  {
    path: 'mde-inventur',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/inventur.component').then((o) => o.InventurComponent),
        children: [
          {
            path: 'start',
            loadComponent: () => import('./pages/start-wizard/start-wizard.component'),
          },
          {
            path: 'artikel-erfassen',
            loadComponent: () =>
              import('./pages/artikel-erfassen/artikel-erfassen.component').then(
                (c) => c.ArtikelErfassenComponent
              ),
            loadChildren: () => [
              {
                loadComponent: () =>
                  import('./pages/artikel-erfassen/schritt1/schritt1.component').then(
                    (c) => c.Schritt1Component
                  ),
                path: 'suche',
              },
              {
                loadComponent: () =>
                  import('./pages/artikel-erfassen/schritt2/schritt2.component').then(
                    (c) => c.Schritt2Component
                  ),
                path: ':idartstamm',
              },
              {
                path: '',
                pathMatch: 'full',
                redirectTo: '/mde-inventur/artikel-erfassen/suche',
              },
            ],
          },
          {
            path: '',
            canActivate: [hasKopfGuard],
            loadComponent: () =>
              import('./pages/erfassung/erfassung.component').then(
                (o) => o.ErfassungComponent
              ),
          },
          {
            path: '**',
            redirectTo: '/mde-inventur',
          },
        ],
      },
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: { permission: SOFTLINE_PERMISSION_MDE_INVENTUR },
    resolve: {
      config: RemoteConfigResolver,
      inventur: InventurResolver,
    },
    providers: [],
    runGuardsAndResolvers: 'always',
  },
];
